module.exports = __webpack_public_path__ + "static/media/flight.58b4d1f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/services/meet_and_greet/flight.jpg
// module id = 166
// module chunks = 0 2